import React, { useState } from 'react';
import { Layout, Typography, Button, Modal, Space, Menu } from 'antd';
import { 
  LogoutOutlined, 
  DashboardOutlined,
  DollarOutlined,
  ApiOutlined,
  BellOutlined,
  TeamOutlined,
  HistoryOutlined,
  CrownOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { useAuthStore } from '../store/authStore';
import { useNavigate, useLocation } from 'react-router-dom';

const { Header } = Layout;
const { Title, Text } = Typography;

const SuperAdminHeader: React.FC = () => {
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    setLogoutModalVisible(false);
    navigate('/login');
  };

  const showLogoutModal = () => {
    setLogoutModalVisible(true);
  };

  // Super Admin navigation items
  const navigationItems = [
    {
      key: '/super-admin/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/super-admin/dashboard'),
    },
    {
      key: '/super-admin/credit-plans',
      icon: <DollarOutlined />,
      label: 'Credit Plans',
      onClick: () => navigate('/super-admin/credit-plans'),
    },
    {
      key: '/super-admin/tenants',
      icon: <TeamOutlined />,
      label: 'Tenants',
      onClick: () => navigate('/super-admin/tenants'),
    },
    {
      key: '/super-admin/api-keys',
      icon: <ApiOutlined />,
      label: 'ERP API Keys',
      onClick: () => navigate('/super-admin/api-keys'),
    },
    {
      key: '/super-admin/webhook-config',
      icon: <BellOutlined />,
      label: 'Webhooks',
      onClick: () => navigate('/super-admin/webhook-config'),
    },
    {
      key: '/super-admin/audit-logs',
      icon: <HistoryOutlined />,
      label: 'Audit Logs',
      onClick: () => navigate('/super-admin/audit-logs'),
    },
    {
      key: '/super-admin/api-docs',
      icon: <ApiOutlined />,
      label: 'API Documentation',
      onClick: () => navigate('/super-admin/api-docs'),
    },
    {
      key: '/super-admin/system-config',
      icon: <SettingOutlined />,
      label: 'System Config',
      onClick: () => navigate('/super-admin/system-config'),
    },
  ];

  const selectedKey = navigationItems.find(item => location.pathname === item.key)?.key || '/super-admin/dashboard';

  return (
    <>
      <Header 
        style={{ 
          background: '#001529', 
          padding: '0 24px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          <Title 
            level={3} 
            style={{ 
              margin: 0, 
              color: 'white', 
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/super-admin/dashboard')}
          >
            TEXO
          </Title>

          <Menu
            mode="horizontal"
            selectedKeys={[selectedKey]}
            items={navigationItems}
            style={{ 
              background: 'transparent', 
              borderBottom: 'none',
              minWidth: '600px'
            }}
            theme="dark"
          />
        </div>

        <Space size="middle">
          <Space direction="vertical" size={0} style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
            <Space size="small" style={{ whiteSpace: 'nowrap' }}>
              <CrownOutlined style={{ color: '#ffd700' }} />
              <Text strong style={{ color: 'white', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block' }}>
                {user?.name || 'Super Admin'}
              </Text>
            </Space>
            <Text type="secondary" style={{ fontSize: '12px', color: '#8c8c8c', whiteSpace: 'nowrap' }}>
              SUPER ADMIN
            </Text>
          </Space>

          <Button
            type="primary"
            danger
            icon={<LogoutOutlined />}
            onClick={showLogoutModal}
          >
            Logout
          </Button>
        </Space>
      </Header>

      <Modal
        title="Confirm Logout"
        open={logoutModalVisible}
        onOk={handleLogout}
        onCancel={() => setLogoutModalVisible(false)}
        okText="Logout"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
      >
        <p>Are you sure you want to logout from the Super Admin Portal?</p>
      </Modal>
    </>
  );
};

export default SuperAdminHeader;
